import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// Components
import LightDark from "Components/Common/LightDark";
// Redux
import { useSelector } from "react-redux";
import { getTranslations, logoutUser } from "slices/thunks";
// Language, Static Datas and Assets
import { updateTranslationsAfterAPI } from "../../i18n";
import { RTL_LANGUAGES, useFilteredLanguages } from "common/locales/languages";
import { RiLogoutBoxLine } from "react-icons/ri";
// Helpers and Hooks
import { getLanguageCodeForTranslation } from "helpers/Others/language_helper";
import { useGlobalHooks } from "hooks/useGlobalHooks";

const SidebarMenuItem = ({ subItems, isAccountMenu, handleClick }: any) => {
  const currentLanguage: any = sessionStorage.getItem("I18N_LANGUAGE");
  const filteredLanguages = useFilteredLanguages();

  const [selectedLang, setSelectedLang] = useState<string>(
    currentLanguage || ""
  );
  const [darkMode, setDarkMode] = useState(false);
  const [layoutMode, setLayoutMode] = useState("light");

  const { dispatch, t } = useGlobalHooks();
  const navigate = useNavigate();

  const translationsState = useSelector((state: any) => state.Translation);
  const { authData } = useSelector((state: any) => state.Dashboard);

  useEffect(() => {
    if (!currentLanguage && authData && authData.culture) {
      const languageCode = getLanguageCodeForTranslation(authData.culture);
      sessionStorage.setItem("I18N_LANGUAGE", languageCode);
      setSelectedLang(languageCode);
      dispatch(getTranslations(languageCode));
    }
  }, [authData.culture]);

  useEffect(() => {
    if (translationsState.translations && selectedLang) {
      updateTranslationsAfterAPI(translationsState.translations, selectedLang);
    }
  }, [translationsState.translations, selectedLang]);

  const changeLanguageAction = (lang: string) => {
    sessionStorage.setItem("I18N_LANGUAGE", lang);
    setSelectedLang(lang);
    handleChangeDirection(lang);
    dispatch(getTranslations(lang));
    // window.location.reload();
  };

  const handleChangeDirection = (lang: string) => {
    const isRtl = RTL_LANGUAGES.includes(lang);
    document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
  };

  useEffect(() => {
    handleChangeDirection(selectedLang);
  }, [selectedLang]);

  const handleLogout = () => {
    dispatch(logoutUser()).then((lang: string) => {
      const redirectLang = lang || "en";
      navigate(`/login/${redirectLang}`);
    });
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const onChangeLayoutMode = (newMode: string) => {
    setLayoutMode(newMode);
  };

  return (
    <>
      {!isAccountMenu ? (
        subItems.map((subItem: any) => (
          <li
            className="nav-item sidebar-menu-item"
            key={`sidebar-menu-item-${subItem.label}`}
            onClick={!subItem.external ? handleClick : undefined}
          >
            {subItem.external ? (
              <a
                href={subItem.link}
                target="_blank"
                rel="noopener noreferrer"
                className="selected"
              >
                {subItem.label}
                {subItem.badgeName && (
                  <span
                    className={`badge badge-pill bg-${subItem.badgeColor}`}
                    data-key="t-new"
                  >
                    {subItem.badgeName}
                  </span>
                )}
              </a>
            ) : (
              <Link
                to={subItem.link ? subItem.link : "/#"}
                className="selected"
              >
                {subItem.label}
                {subItem.badgeName && (
                  <span
                    className={`badge badge-pill bg-${subItem.badgeColor}`}
                    data-key="t-new"
                  >
                    {subItem.badgeName}
                  </span>
                )}
              </Link>
            )}
          </li>
        ))
      ) : (
        <>
          {subItems.map((subItem: any) => (
            <li
              className="nav-item sidebar-menu-item"
              key={`sidebar-menu-item-${subItem.label}`}
              onClick={handleClick}
            >
              <Link
                to={subItem.link ? subItem.link : "/#"}
                className="selected"
              >
                {subItem.label}
                {subItem.badgeName && (
                  <span
                    className={`badge badge-pill bg-${subItem.badgeColor}`}
                    data-key="t-new"
                  >
                    {subItem.badgeName}
                  </span>
                )}
              </Link>
            </li>
          ))}

          <div className="nav-item sidebar-menu-item mt-4">
            <h3 className="sidebar-sub-menu-title">{t("language")}</h3>
            <ul className="language-menu">
              {filteredLanguages.map((language, index) => (
                <li
                  key={`language-menu-${language.languageTitle}`}
                  className={
                    language.languageCode == selectedLang ? "active" : "none"
                  }
                  onClick={() => changeLanguageAction(language.languageCode)}
                >
                  <span>{language.languageTitle}</span>
                </li>
              ))}
            </ul>

            {/* <label htmlFor="toggleButton" className="switch theme-toggle mt-5">
              <input
                type="checkbox"
                name="toggleButton"
                id="toggleButton"
                checked={darkMode}
                onChange={toggleDarkMode}
              />
              <div className="switch-button">
                <span></span>
              </div>
              <span className="text">Dark Mode</span>
            </label> 
            */}

            {/* <LightDark
              layoutMode={layoutMode}
              onChangeLayoutMode={onChangeLayoutMode}
            /> */}

            <hr className="d-none d-lg-block mt-3" />

            <div className="logout d-none d-lg-block mt-3">
              <div
                className="d-flex align-items-center cursor-pointer gap-2"
                onClick={handleLogout}
              >
                <RiLogoutBoxLine size={23} />
                <span className="text">{t("logout")}</span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SidebarMenuItem;
